/**
 * @namespace PIXI.spine
 */
module.exports = PIXI.spine = {
    Spine:          require('./Spine'),
    SpineRuntime:   require('./SpineRuntime'),
    loaders:        require('./loaders')
};
